import {
  Input, SimpleChanges, OnChanges,
  Component,
  OnInit
} from '@angular/core';
import {CompanyService} from "../../services/company-service/company-service";


@Component({

  selector: 'rw-whatsapp-support',  // <home></home>

  styles: [require('./whatsapp-support.component.css')],

  template: require('./whatsapp-support.component.html')
})
export class WhatsappSupportComponent implements OnInit, OnChanges {


  whatsappNumber: string = null;
  public companySocials: any[];

  constructor(private companyService: CompanyService) {
  }

  public ngOnInit() {

    window.addEventListener("scroll", this.onScrollChange);

    this.companyService.getCompanyInfo().subscribe((c) => {
      this.companyService.getCompanySocialNetwork(c.id).subscribe((sns) => {
        sns.forEach((s) => {
          if (s.socialNetworkType == 'WHATSAPP')
            this.whatsappNumber = s.url;
        })
      })

    })

  }

  onScrollChange($event) {
    let parent = this;
    let elem = document.getElementById("whatsappSupport");
    if(!elem)
      return;
    let pageHeight = document.body.scrollHeight;
    let scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

    if (pageHeight - scrollPosition < 700) {
      elem.style.display = 'none';
    } else {
      elem.style.display = 'flex';
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    let parent = this;
  }


  sendWhatsAppMessage() {
    if(this.whatsappNumber){
      let url = "https://api.whatsapp.com/send?phone=";
      url = url + this.whatsappNumber;
      window.open(url, '_blank');
    }
  }


}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/whatsapp-support/whatsapp-support.component.ts